import axios from 'axios'

import isArrayLike from 'lodash/isArrayLike'
import isObjectLike from 'lodash/isObjectLike'
import isNumber from 'lodash/isNumber'
import unzip from 'lodash/unzip'
import toPairs from 'lodash/toPairs'
import zipObject from 'lodash/zipObject'
import forEach from 'lodash/forEach'
import chunk from 'lodash/chunk'
import map from 'lodash/map'

const _All = function(iterable) {
  if(isArrayLike(iterable)) return Promise.all(iterable)
  if(!isObjectLike(iterable)) throw new Error('invalid iterable')

  // const keys = keys(iterable)
  // const vals = values(iterable)

  const [ keys, vals ] = [...unzip(toPairs(iterable))]
  return Promise
    .all(vals)
    .then(results => zipObject(keys, results))
}

const _AllLimit = function(iterable, limit, intervalMS) {
  let p

  if(!(isNumber(limit) && limit > 0))
    throw new Error('invalid limit')

  p = Promise.resolve()

  if(isArrayLike(iterable)) {
    const results = []

    forEach(chunk(iterable, limit), chunk => {

      p = p.then(() => {
        return Promise
          .all(map(chunk, promiseFn => promiseFn())).then(res => {
            forEach(res, x => results.push(x))
          })
      })
      if(isNumber(intervalMS) && intervalMS > 0)
        p = p.then(() => new Promise(
          resolve => setTimeout(resolve, intervalMS)))
    })
    p = p.then(() => results)
  } else if(isObjectLike(iterable)) {
    const results = {}
    const pairs = toPairs(iterable)
    forEach(chunk(pairs, limit), chunk => {
      // forEach(chunk, pair => {
      // const key = pair[0]
      // const promiseFn = pair[1]
      const [keys, vals] = [...unzip(chunk)]
      p = p.then(() => {
        // return promiseFn().then(res => (results[key] = res))
        return Promise
          .all(map(vals, promiseFn => promiseFn()))
          .then(res => {
            forEach(
              zipObject(keys, res),
              (result, key) => (results[key] = result))
          })
      })
      // })
      if(isNumber(intervalMS) && intervalMS > 0)
        p = p.then(() => new Promise(
          resolve => setTimeout(resolve, intervalMS)))
    })
    p = p.then(() => results)
  } else throw new Error('invalid iterable')

  return p
}

const _AllSeries = function(iterable, intervalMS) {
  let p = Promise.resolve()
  if(isArrayLike(iterable)) {
    const results = []
    forEach(iterable, promiseFn => {
      p = p.then(() => {
        return promiseFn().then(res => results.push(res))
      })
      if(isNumber(intervalMS) && intervalMS > 0)
        p = p.then(() => new Promise(
          resolve => setTimeout(resolve, intervalMS)))
    })
    p = p.then(() => results)
  } else if(isObjectLike(iterable)) {
    const results = {}
    const [ keys, vals ] = [...unzip(toPairs(iterable))]
    forEach(vals, (promiseFn, i) => {
      let key = keys[i]
      p = p.then(() => {
        return promiseFn().then(res => (results[key] = res))
      })
      if(isNumber(intervalMS) && intervalMS > 0)
        p = p.then(() => new Promise(
          resolve => setTimeout(resolve, intervalMS)))
    })
    p = p.then(() => results)
  } else throw new Error('invalid iterable')
  return p
}

axios.Axios.prototype.all = _All
axios.Axios.prototype.allLimit = _AllLimit
axios.Axios.prototype.allSeries = _AllSeries



// WEBPACK FOOTER //
// ./src/saltapi/enhancedAxios.js